import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { BookAVisitDialog } from "./book-a-visit-dialog";
import { Button } from "./ui/button";

export function HeroBottomBar() {
  return (
    <div className="flex items-center w-full p-4 absolute bottom-4 gap-3 left-0 right-0 h-16">
      <div className="w-1/2 hidden sm:block">
        <Link href="/ordinacija" aria-label="Ordinacija">
          <Button
            effect="shineHover"
            icon={ArrowRight}
            iconPlacement="right"
            className="w-full h-16 cursor-pointer bg-brand-900 hover:bg-brand-900/95"
          >
            <p className="text-background text-lg tracking-[-0.04em] leading-[110%] font-medium hidden md:block">
              Ordinacija
            </p>
          </Button>
        </Link>
      </div>
      <div className="w-full md:w-1/2">
        <BookAVisitDialog className=" sm: sm: sm:" />
      </div>
    </div>
  );
}
